import { render, staticRenderFns } from "./ResponsibilityCardHeader.vue?vue&type=template&id=7ffa5b87&scoped=true"
import script from "./ResponsibilityCardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityCardHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityCardHeader.vue?vue&type=style&index=0&id=7ffa5b87&prod&scoped=true&lang=css"
import style1 from "./ResponsibilityCardHeader.vue?vue&type=style&index=1&id=7ffa5b87&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa5b87",
  null
  
)

export default component.exports